import { render, staticRenderFns } from "./InfoColumn.vue?vue&type=template&id=b3bcf9e8&scoped=true&"
import script from "./InfoColumn.vue?vue&type=script&lang=js&"
export * from "./InfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./InfoColumn.vue?vue&type=style&index=0&id=b3bcf9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bcf9e8",
  null
  
)

export default component.exports